import type {Event, EventHint} from '@sentry/react';

// The API telling the user no (wrong password, form validation, logged out, ended subscription).
// The backend logs the ones that matter; 403, 404, 429, 5xx and network errors are still reported.
const EXPECTED_API_STATUSES = [400, 401, 409, 422];

// Errors from the user's own device or browser, or from a call whose connection is dropping: nothing to fix
export const ignoreErrors = [
    // camera, microphone, screen share and autoplay
    /NotAllowedError/,
    /NotReadableError/,
    /Could not start video source/,
    /Timeout starting video source/,
    /Device in use/,
    /Permission (denied|dismissed)/,
    /getDisplayMedia not supported/,
    /AbortError/,
    /The play\(\) request was interrupted/,
    // livekit while the connection drops
    /cannot publish track when not connected/,
    /publication of local track timed out/,
    /RTCPeerConnection is closed/,
    /InvalidStateError/,
    // a tab from before a deploy loading an old chunk: lazyRetry reloads the page
    /Unexpected token '<'/,
    // Outlook Safe Links scanning emailed links
    'Object Not Found Matching Id',
    // browser extensions and the Tawk chat widget
    /runtime\.sendMessage/,
    /Socket server did not execute the callback/,
];

export const denyUrls = [
    /tawk\.to/i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-(web-)?extension:\/\//i,
];

export const beforeSend = (event: Event, hint?: EventHint) => {
    const error = hint?.originalException as any;
    if (
        error?.isAxiosError &&
        EXPECTED_API_STATUSES.includes(error.response?.status)
    )
        return null;
    return event;
};
